import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { BehaviorSubject } from 'rxjs';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { PageId } from 'src/app/shared/utilities/pageids.enum';

@Injectable({
  providedIn: 'root',
})
export class BusinessAccountsService {
  private newBusinessHeroSubject$ = new BehaviorSubject<any>(null);
  public newBusiness$ = this.newBusinessHeroSubject$.asObservable();

  private businessAccSubject$ = new BehaviorSubject<any>(null);
  public businessAcc$ = this.businessAccSubject$.asObservable();

  private efficientSubject$ = new BehaviorSubject<any>(null);
  public efficient$ = this.efficientSubject$.asObservable();

  private globalReachSubject$ = new BehaviorSubject<any>(null);
  public globalReach$ = this.globalReachSubject$.asObservable();

  private exporeMoreSubject$ = new BehaviorSubject<any>(null);
  public exploreMore$ = this.exporeMoreSubject$.asObservable();

  private multiCurrencySubject$ = new BehaviorSubject<any>(null);
  public multiCurrency$ = this.multiCurrencySubject$.asObservable();

  private dLocalSubject$ = new BehaviorSubject<any>(null);
  public dLocal$ = this.dLocalSubject$.asObservable();

  private internationalSubject$ = new BehaviorSubject<any>(null);
  public international$ = this.internationalSubject$.asObservable();

  private readyToSubject$ = new BehaviorSubject<any>(null);
  public readyTo$ = this.readyToSubject$.asObservable();

  private faqSubject$ = new BehaviorSubject<any>(null);
  public faq$ = this.faqSubject$.asObservable();

  private insightsSubject$ = new BehaviorSubject<any>(null);
  public insights$ = this.insightsSubject$.asObservable();

  private discoverSubject$ = new BehaviorSubject<any>(null);
  public discover$ = this.discoverSubject$.asObservable();

  constructor(private contentful: ContentfulService) {}

  businessPageData: any;

  getBusinessAccPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.solutionsPage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.businessPageData = mod.filter(
          x => x?.fields['id'] == PageId.businessAcc
        );
        const businessAcc = this.businessPageData[0].fields;

        if (businessAcc) {
          this.businessAccSubject$.next(businessAcc);
        }

        const newBusinessHeroHeader =
          this.businessPageData[0].fields.psHeroPanel.fields;
        if (newBusinessHeroHeader) {
          this.newBusinessHeroSubject$.next(newBusinessHeroHeader);
        }

        const efficientSubjectPanelData =
          this.businessPageData[0].fields.psValuePropPanel.fields;
        if (efficientSubjectPanelData) {
          this.efficientSubject$.next(efficientSubjectPanelData);
        }

        const globalReachPanelData =
          this.businessPageData[0].fields.psProductSuite2.fields;
        if (globalReachPanelData) {
          this.globalReachSubject$.next(globalReachPanelData);
        }

        const exploreMorePanelData =
          this.businessPageData[0].fields.psOtherProductsPanel.fields;
        if (exploreMorePanelData) {
          this.exporeMoreSubject$.next(exploreMorePanelData);
        }

        const multiCurrencyPanelData =
          this.businessPageData[0].fields.psProductSuite.fields;
        if (multiCurrencyPanelData) {
          this.multiCurrencySubject$.next(multiCurrencyPanelData);
        }

        const dLocalPanelData =
          this.businessPageData[0].fields.psCustomerStatsContentPanel.fields;
        if (dLocalPanelData) {
          this.dLocalSubject$.next(dLocalPanelData);
        }

        const internationalPanelData =
          this.businessPageData[0].fields.psValuePropPanel2.fields;
        if (internationalPanelData) {
          this.internationalSubject$.next(internationalPanelData);
        }

        const readyToPanelData =
          this.businessPageData[0].fields.psGetStartedPanel.fields;
        if (readyToPanelData) {
          this.readyToSubject$.next(readyToPanelData);
        }

        const faqSubjectPanelData =
          this.businessPageData[0].fields.psFaqPanel.fields;
        if (faqSubjectPanelData) {
          this.faqSubject$.next(faqSubjectPanelData);
        }

        const insightsPanelData =
          this.businessPageData[0].fields.psBlogPanel[0].fields;
        if (insightsPanelData) {
          this.insightsSubject$.next(insightsPanelData);
        }

        const discoverPanelData =
          this.businessPageData[0].fields.psCustomerStories.fields;
        if (discoverPanelData) {
          this.discoverSubject$.next(discoverPanelData);
        }
      });
  }
}
